<template>
    <div style="text-align: center">
        <div v-if="row.type == 0 && $can('change-status', 'settlement')" class="dropdown">
            <button type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm" data-toggle="dropdown" data-target="#myModal">
                <i class="fa fa-cog"></i>
            </button>
            <div class="dropdown-menu">
                <h5 class="dropdown-header">{{ $t('label.change_status_to') }}</h5>
                <button
                        id="change_status_btn"
                        v-for="(status, index) in get_statuses(row.status)"
                        @click="changeStatus(status.int)"
                        class="dropdown-item"
                        v-bind:key="index"
                >
                    {{ status.str }}
                </button>
            </div>
        </div>

        <router-link :to="{path: '/settlements/'+row.id+'/details', query: row.is_direct ? {direct: 1} : {}}" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i class="fa fa-eye"></i>
        </router-link>
        <rejection-reasons v-if="row.type === 0 && row.status === settlementStatus.REJECTED && row.rejection_reasons !== null"
                           :datatable="datatable"
                           :index="index"
                           :row="row"
        >
        </rejection-reasons>
    </div>
</template>

<script>
import Vue from 'vue'
import { statusStr, settlementStatus } from '@/constants/settlementStatus'
import { settlementService } from '@/common/api.service'
import toastr from 'toastr'
import { i18n } from '@/plugins/i18n'
import RejectionReasons from '../component/rejection-reasons'

export default Vue.extend({
    components: {RejectionReasons},
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    data() {
        return {
            settlementStatus: settlementStatus
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-top-left",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },
    methods: {
        get_statuses(current_status) {
            let statuses = []
            // Direct (PSP) settlements can only be accepted or rejected
            if (this.row.is_direct) {
                return [settlementStatus.ACCEPTED, settlementStatus.REJECTED]
                    .filter(status => status !== current_status)
                    .map(status => ({int: status, str: statusStr.get(status)}))
            }
            for (let i = 0; i < 7; i++) {
                if (current_status !== i) {
                    statuses.push({
                        int: i,
                        str: statusStr.get(i)
                    })
                }
            }

            return statuses
        },
        changeStatus(status) {
            let request = this.row.is_direct
                ? settlementService.changePspSettlementStatus(this.row.id, status)
                : settlementService.changeStatus(this.row.id, status)
            request.then(response => {
                this.toastr.success(i18n.t('settlement.change_succeeded'))
                this.datatable.reload()
            }).catch(({response}) => {
                this.toastr.fail(i18n.t('settlement.change_failed'))
            })
        }
    }
})
</script>